function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill-rule:evenodd;clip-rule:evenodd;}");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M69.76,26.16l-7.75,7.75L54.02,42L42.21,53.81l-8.09,7.99l-7.54,7.54c-1.4,1.4-3.68,1.4-5.08,0l-2.95-2.95 c-1.4-1.4-1.4-3.68,0-5.08l43.18-43.18c1.4-1.4,3.68-1.4,5.08,0l2.95,2.95C71.16,22.48,71.16,24.76,69.76,26.16L69.76,26.16z M48.35,26.93L26.93,48.36l-3.18-3.18l21.42-21.42L48.35,26.93L48.35,26.93z M53.12,96.3l7.75-7.75L45.28,72.96 c-2.21-2.21-2.21-5.83,0-8.04l0,0c2.21-2.21,5.83-2.21,8.04,0l15.54,15.54l11.81-11.81L65.13,53.11c-2.21-2.21-2.21-5.83,0-8.04 l0,0c2.21-2.21,5.83-2.21,8.04,0l15.59,15.59l7.54-7.54c1.4-1.4,3.68-1.4,5.08,0l2.95,2.95c1.4,1.4,1.4,3.68,0,5.08l-43.18,43.18 c-1.4,1.4-3.68,1.4-5.08,0l-2.95-2.95C51.72,99.99,51.72,97.7,53.12,96.3L53.12,96.3z M74.48,95.48L95.9,74.06l3.18,3.18 L77.66,98.66L74.48,95.48L74.48,95.48z M63.14,102.33l6.2,6.21c10.79,10.79,20.86,11.28,33.18,1.61l12.31,12.31l8.04-8.04 l-12.41-12.41c9.83-11.93,8.34-23.24-2.11-33.69l-5.6-5.6L63.14,102.33L63.14,102.33z M59.74,20.13l-6.2-6.21 C42.75,3.13,32.67,2.64,20.36,12.31L8.04,0L0,8.04l12.41,12.41c-9.83,11.93-8.34,23.24,2.11,33.69l5.6,5.6L59.74,20.13L59.74,20.13 z"
}));

function SvgBatteryBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 122.46",
    style: {
      enableBackground: "new 0 0 122.88 122.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryBox);
export default __webpack_public_path__ + "static/media/batteryBox.1cff570f.svg";
export { ForwardRef as ReactComponent };